import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Alert, Confirm } from '../models/alert';
import {AlertComponent} from '../components/alert/alert.component';

@Injectable()
export class AlertService {
  /**
   * Constructor
   */
  constructor(private modalService: NgbModal) {}

  /**
   * Show alert
   */
  public alert(body, alert: Alert = {}) {
    const modalRef = this.modalService.open(AlertComponent, {
      size: alert.size ? alert.size as 'sm'  : 'sm' // Act as if size is 'sm', otherwise only 'sm' and 'lg' are available in component
    });

    modalRef.componentInstance.type = 'alert';
    modalRef.componentInstance.title = alert.title;
    modalRef.componentInstance.body = body;
    modalRef.componentInstance.btnClose = alert.btnClose;

    modalRef.result.then(
        () => {
          if (alert.close) {
            alert.close();
          }
        },
        dismiss => {}
    );
  }

  /**
   * Show confirm
   */
  public confirm(body, confirm: Confirm = {}) {
    const modalRef = this.modalService.open(AlertComponent, {
      size: confirm.size ? confirm.size as 'sm' : 'sm' // Act as if size is 'sm', otherwise only 'sm' and 'lg' are available in component
    });

    modalRef.componentInstance.type = 'confirm';
    modalRef.componentInstance.title = confirm.title;
    modalRef.componentInstance.body = body;
    modalRef.componentInstance.btnClose = confirm.btnClose;
    modalRef.componentInstance.btnCancel = confirm.btnCancel;

    modalRef.result.then(
        () => {
          if (confirm.close) {
            confirm.close();
          }
        },
        dismiss => {
          if (confirm.cancel) {
            confirm.cancel();
          }
        }
    );
  }
}
